module.exports = __webpack_public_path__ + "static/media/SF-10-A.4fdc8fe7.mp3";